import { Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectIsAuthenticated } from "../../redux/selectors/authSelector";
import { RouteName } from "../../utils/routing/routes.helper";
import Skeleton from "../admin-panel/skeleton/skeleton";
import DialogStatus from "../common/dialog-status/dialog-status";

const ProtectedRoute = () => {
  const isAuthenticated = useSelector(selectIsAuthenticated);

  if (!isAuthenticated) {
    return <Navigate to={RouteName.LOGIN} replace />;
  }

  return (
    <Skeleton>
      <Outlet />
      <DialogStatus />
    </Skeleton>
  );
};

export default ProtectedRoute;
